import { render, staticRenderFns } from "./PaymentCancelled.vue?vue&type=template&id=80649476&scoped=true&"
import script from "./PaymentCancelled.vue?vue&type=script&lang=js&"
export * from "./PaymentCancelled.vue?vue&type=script&lang=js&"
import style0 from "./PaymentCancelled.vue?vue&type=style&index=0&id=80649476&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80649476",
  null
  
)

export default component.exports